// composables/useUnsavedChangesGuard.ts
import { ref, watch, onMounted } from "vue";
import { onBeforeRouteLeave } from "vue-router";
import Swal from "sweetalert2";
import i18n from "@/i18n/index";

export function useUnsavedChangesGuard(getTargetData: () => any) {
  const hasUnsavedChanges = ref(false);
  let initialDataSnapshot = "";

  // 1. كناخدو النسخة الأصلية ديال البيانات منين كتحل الصفحة
  onMounted(() => {
    setTimeout(() => {
      const data = getTargetData();
      if (data) {
        initialDataSnapshot = JSON.stringify(data);
      }
    }, 300);
  });

  // 2. دالة جديدة: كنعيطو ليها مورا ما نديرو Save باش نحدثو النسخة الأصلية
  const updateInitialState = () => {
    const data = getTargetData();
    if (data) {
      initialDataSnapshot = JSON.stringify(data);
      hasUnsavedChanges.value = false; // كنردوها false ضروري
    }
  };

  // 3. مراقبة أي تغيير كيطرا
  watch(
    getTargetData,
    (newValue) => {
      if (!initialDataSnapshot) return;

      const currentDataSnapshot = JSON.stringify(newValue);

      if (currentDataSnapshot !== initialDataSnapshot) {
        hasUnsavedChanges.value = true;
      } else {
        hasUnsavedChanges.value = false;
      }
    },
    { deep: true },
  );

  // 4. حارس الخروج من الصفحة
  onBeforeRouteLeave((to, from, next) => {
    if (hasUnsavedChanges.value) {
      Swal.fire({
        title: i18n.t("message.unsavedchanges.title"),
        text: i18n.t("message.unsavedchanges.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: i18n.t("button.yes"),
        cancelButtonText: i18n.t("button.cancel"),
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  });

  return {
    hasUnsavedChanges,
    updateInitialState, // 👈 رد البال رديناها هنا باش تستعملها فالبلاصة اللي بغيتي
  };
}
